import React from 'react';
import { Popover, Tag, Whisper } from 'rsuite';
import { OverlayTriggerType } from 'rsuite/cjs/internals/Overlay/OverlayTrigger';
import { GeneratedDocument } from '../../api/generateddocuments/generatedDocumentsApiTypes';

interface Props {
  document: GeneratedDocument;
}

function getStatusTrigger(document: GeneratedDocument): OverlayTriggerType {
  return document.errorMessage ? 'hover' : 'none';
}

export default function GeneratedDocumentStatusCell({ document }: Props) {
  return (
    <Whisper
      trigger={getStatusTrigger(document)}
      delay={200}
      speaker={(
        <Popover
          className="error-message-tooltip"
          arrow={false}
        >
          <p>{document.errorMessage}</p>
        </Popover>
      )}
    >
      <Tag
        size="sm"
        className={`generated-document-status-${document.status}`}
      >
        {document.status}
      </Tag>
    </Whisper>
  );
}
